import { AnaColumn } from "../forms-template.service";

export const crmEmailInviateGrid: AnaColumn[] = [
  {
    itemType: "group", colCount: "1", class: "", caption: "Email Inviate",
    data: [
      {
        type: 'buttonArray',
        dataField: "",
        hideOnEdit: true,
        width: 30,
        disabled: false,
        class: 'text-center',
        horizontalAlignment: 'center',
        colAlignment: 'center',
        odataFilter: '',
        buttonArray: [
          {
            event: "showContent",
            name: "showContent",
            hint: "Mostra Contenuto",
            icon: "bi bi-envelope-fill",
            class: 'customBtnCrm showContent'
          },
        ]
      },
      {
        type: 'campo',
        dataField: 'id',
        colVisible: false,
        dataType: 'string',
        caption: 'Cod ID',
        colAlignment: 'left',
        colWidth: 50
      },
      // {
      //   type: 'campo',
      //   dataField: 'CodContatto',
      //   colVisible: true,
      //   dataType: 'string',
      //   caption: 'Contatto',
      //   colAlignment: 'left',
      //   lista: {
      //     dataSource: 'contatti',
      //     valueExpr: 'Cod',
      //     Async: true,
      //     displayExpr: 'RagSoc',
      //     wingap: false
      //   }
      // },
      {
        type: 'campo',
        dataField: 'mittente',
        colVisible: false,
        dataType: 'string',
        caption: 'Mittente',
        colAlignment: 'left',
      },
      {
        type: 'campo',
        dataField: 'destinatari',
        colVisible: true,
        dataType: 'string',
        caption: 'Destinatari',
        colAlignment: 'left',

      },
      {
        type: 'campo',
        dataField: 'utente',
        colVisible: true,
        dataType: 'string',
        caption: 'Utente',
        colAlignment: 'left',

      },
      {
        type: 'campo',
        dataField: 'oggetto',
        colVisible: true,
        dataType: 'string',
        caption: 'Oggetto',
        colAlignment: 'left',

      },
      {
        type: 'campo',
        dataField: 'in_copia',
        colVisible: false,
        dataType: 'string',
        caption: 'In Copia',
        colAlignment: 'left',
      },

      {
        type: 'campo',
        dataField: 'note',
        colVisible: true,
        dataType: 'string',
        caption: 'Note',
        colAlignment: 'left',
        colWidth: 400
      },
      {
        type: 'campo',
        dataField: 'data_invio',
        colVisible: true,
        dataType: 'date',
        caption: 'Data',
        colAlignment: 'center',
        colWidth: 120
      },
    ]
  }
]